import { StatusType } from "@themes/aegix";
import { UserFormInitialValues } from "../types/UserFormInitialValue";
export interface UserRow extends UserFormInitialValues {
    id: string;
    name: string;
    email: string;
    role: string;
    status: StatusType;
    vendor_display?: string;
}
export function transformUsers(apiUsers: UserFormInitialValues[]): UserRow[] {
    return apiUsers.map((user) => {
        const name =
            [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email;
        return {
            name,
            role: user.is_superuser ? 'Admin' : user.is_staff ? 'Staff' : 'User',
            status: user.is_active ? 'active' : 'inactive',
            vendor_display: user.vendor_name || '',

            // keep original api fields if UserRow expects them
            ...user,
            id: user.id || '',
        };
    });
}